import { css } from '@emotion/react'

/**
 * antd Select のドロップダウン選択肢で長いテキストが省略されないように折り返し表示にする。
 * setupAntd.tsx の AntdConfigProvider 内で Global スタイルとして適用される。
 */
export const antdSelectOptionWrapStyle = css`
  .ant-select-item-option-content {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
  }
`
